import {Component, Input} from '@angular/core';
import {DashboardGridCardItem} from "../../../models/ui/gridcard";

@Component({
  standalone: false,
  selector: 'app-dashboard-card-grid',
  templateUrl: './dashboard-card-grid.component.html',
  styleUrls: ['./dashboard-card-grid.component.css']
})
export class DashboardCardGridComponent {

  @Input() columns!: number;
  @Input() gridCardItems!: DashboardGridCardItem[];

}
